export const COLORS = {
  lightBlack: '#393955',
  black: '#333333',
  blueLight: '#6585F5',
  blue: '#3F66F3',
  blueDark: '#2346C4',
  blueHover: '#EBEFFD',
  grayBorder: '#EBEAE9',
  grayFadedBorder: '#B0B0BB',
  grayText: '#616177',
  grayTextDisabled: '#B0B0BB',
  grayDisabled: '#D8D6D4',
  grayBackground: '#F6F4F1',
  grayLightDisabled: '#E9E3DB',
  grayHover: '#BFBFBF',
  purple: '#393955',
  white: '#FFFFFF',
  red: '#F6564D',
};
